import fetch from '@rd-web-markets/shared/dist/services/Fetcher';
import { request } from '@rd-web-markets/shared/dist/services/request';
import { useCallback } from 'react';
import serviceMethods from './service_methods';
import { buildService } from './service';
const api = buildService('/companies/{id}/themes', {
  only: ['all']
});
const themesService = {
  create(companyId, theme) {
    return fetch(`/api/companies/${companyId}/themes`, {
      ...request.post,
      body: JSON.stringify({
        theme
      })
    });
  },
  useFetchAll: _ref => {
    let {
      setLoading,
      companyId
    } = _ref;
    const [themes, setThemes, fetchThemes] = serviceMethods.useFetch({
      callback: useCallback(async () => {
        if (!companyId) {
          return [];
        }
        const response = await api.all(companyId);
        return Array.isArray(response) ? response : response.themes;
      }, [companyId]),
      setLoading,
      initialStateValue: []
    });
    return [themes, setThemes, fetchThemes];
  }
};
export default themesService;